export interface DateState {
    date?: number | null
}

export enum DateStateTypes {
    GET_DATE = "@@datestate/GET_DATE",
    SET_DATE = "@@datestate/SET_DATE"
}